import styled from '@common/theme/styled-components';

export const Map = styled.div``;

export const MapFrame = styled.iframe`
  border: 0;
  border-radius: ${(props) => props.theme.borderRadiuses.small};
`;
